import { AbsoluteFill, Sequence, Video, Img, staticFile, interpolate, useCurrentFrame } from "remotion";

// Scene 2b + Scene 3 combined: continues the push-in on the real product
// photo (Ken Burns, deterministic, zero GPU/model risk) that started in the
// ComfyUI clip, then holds while the tagline fades in/out.
const HeroPhotoScene: React.FC = () => {
  const frame = useCurrentFrame();

  // 0-165 (5.5s @30fps): push-in continues. 165-240 (2.5s): clamped hold.
  const scale = interpolate(frame, [0, 165], [1.05, 1.22], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const line1Opacity = interpolate(frame, [169, 173, 231, 236], [0, 1, 1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const line1Blur = interpolate(frame, [169, 173, 231, 236], [8, 0, 0, 8], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const line2Opacity = interpolate(frame, [192, 198, 231, 236], [0, 1, 1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const line2Blur = interpolate(frame, [192, 198, 231, 236], [8, 0, 0, 8], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ backgroundColor: "#060604", overflow: "hidden" }}>
      <AbsoluteFill style={{ transform: `scale(${scale})`, transformOrigin: "50% 50%" }}>
        <Img
          src={staticFile("reel-assets/akshar-island-decal/decal-red-island.png")}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </AbsoluteFill>
      <AbsoluteFill
        style={{
          alignItems: "center",
          justifyContent: "flex-end",
          paddingBottom: 420,
        }}
      >
        <div
          style={{
            opacity: line1Opacity,
            filter: `blur(${line1Blur}px)`,
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: 40,
            color: "#fdf6e8",
            textShadow: "0 4px 18px rgba(0,0,0,0.7)",
            letterSpacing: "0.01em",
            textAlign: "center",
          }}
        >
          Cut &amp; applied by hand
        </div>
        <div
          style={{
            marginTop: 10,
            opacity: line2Opacity,
            filter: `blur(${line2Blur}px)`,
            fontFamily: "Inter, sans-serif",
            fontWeight: 300,
            fontSize: 32,
            color: "#c9a765",
            letterSpacing: "0.05em",
            textAlign: "center",
          }}
        >
          on Prince Edward Island
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};

// Scene timing @30fps (540 frames total = 18.0s):
//   0-180    (6.0s)  Scene 1 — HyperFrames brand hook (reused clip)
//   180-225  (1.5s)  Scene 2a — ComfyUI HunyuanVideo i2v hero shot (QC-trimmed)
//   225-465  (8.0s)  Scene 2b+3 — Ken Burns continuation + tagline card
//   465-540  (2.5s)  Scene 4 — HyperFrames real-logo reveal
export const AksharIslandDecalReel: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: "#000000" }}>
      <Sequence from={0} durationInFrames={180}>
        <Video src={staticFile("hyperframes-in/akshar-intro/akshar-intro-test.mp4")} />
      </Sequence>

      <Sequence from={180} durationInFrames={45}>
        <AbsoluteFill style={{ backgroundColor: "#060604" }}>
          <Video
            src={staticFile("reel-assets/akshar-island-decal/scene2-hero-clip.mp4")}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </AbsoluteFill>
      </Sequence>

      <Sequence from={225} durationInFrames={240}>
        <HeroPhotoScene />
      </Sequence>

      <Sequence from={465} durationInFrames={75}>
        <Video src={staticFile("hyperframes-in/akshar-logo-outro/akshar-logo-outro-test.mp4")} />
      </Sequence>
    </AbsoluteFill>
  );
};
